import { AxiosPromise } from 'axios';

import { userInstance } from './config';
import { res } from './utils';

type SignupParams = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  referral?: string;
  affiliate?: string;
  newsletter?: boolean;
};

const signup = ({
  firstName,
  lastName,
  email,
  password,
  referral,
  affiliate,
  newsletter,
}: SignupParams): AxiosPromise =>
  userInstance.post('/signup', {
    firstName,
    lastName,
    email,
    password,
    referral,
    affiliate,
    newsletter,
  });

type LoginParams = {
  email: string;
  password: string;
};

const login = ({ email, password }: LoginParams): AxiosPromise =>
  userInstance.post('/login', {
    email,
    password,
  });

const logout = (): AxiosPromise => userInstance.post('/logout');

const getInfo = (): AxiosPromise => userInstance.get('/info');

type UpdateUserParams = {
  firstName: string;
  lastName: string;
};

const updateInfo = ({ firstName, lastName }: UpdateUserParams): AxiosPromise =>
  userInstance.patch('/info', {
    firstName,
    lastName,
  });

const getBillingInfo = (): AxiosPromise => userInstance.get('/billing_info');

type RequestPasswordResetParams = {
  email: string;
};

const requestPasswordReset = ({ email }: RequestPasswordResetParams): AxiosPromise =>
  userInstance.post('/request_password_reset', {
    email,
  });

type ResetPasswordParams = {
  password: string;
  secret: string;
};

const resetPassword = ({ password, secret }: ResetPasswordParams): AxiosPromise =>
  userInstance.post('/reset_password', {
    password,
    secret,
  });

type ActivateParams = {
  secret: string;
};

const activate = ({ secret }: ActivateParams): AxiosPromise =>
  userInstance.post('/activate', {
    secret,
  });

type NewsletterOptinParams = {
  secret: string;
};

const newsletterOptin = ({ secret }: NewsletterOptinParams): AxiosPromise =>
  userInstance.post('/optin_marketing', {
    secret,
  });

type ResendConfirmationParams = {
  email: string;
};

const resendConfirmationEmail = ({ email }: ResendConfirmationParams): AxiosPromise =>
  userInstance.post('/resend_confirmation_email', {
    email,
  });

const deleteAccount = (): AxiosPromise => userInstance.post('/delete_account');

const generateApiKey = (): AxiosPromise => userInstance.post('/generate_api_key');

const cancelActiveSub = (): AxiosPromise => userInstance.post('/cancel_active_sub');

type UpdateSubscriptionParams = {
  stripePlanId: string;
};

const updateSubscription = ({ stripePlanId }: UpdateSubscriptionParams): AxiosPromise =>
  userInstance.post('/update_subscription_plan', {
    stripePlanId,
  });

const getFavorites = (): AxiosPromise => userInstance.get('/favorites').then(res);

const updateFavorites = (data: any = []): AxiosPromise => userInstance.put('/favorites', data);

const getDashboards = (): AxiosPromise => userInstance.get('/dashboards').then(res);

const createDashboard = (data: any = {}): AxiosPromise => userInstance.post('/dashboards/create', data);

export default {
  activate,
  cancelActiveSub,
  createDashboard,
  deleteAccount,
  generateApiKey,
  getBillingInfo,
  getDashboards,
  getFavorites,
  getInfo,
  login,
  logout,
  newsletterOptin,
  requestPasswordReset,
  resendConfirmationEmail,
  resetPassword,
  signup,
  updateFavorites,
  updateInfo,
  updateSubscription,
};
